export default __webpack_public_path__ + "static/Logo-05-013da1828cd77655789b0f972ed25075.png";